import React from 'react'
import { Badge, Group } from '@mantine/core'
import { within } from '../../util/date.util'

/**
 * Renders a group of badges that related to a job posting.
 * @typedef {object} BadgesProps
 * @property {object} jobPosting The job posting to render badges for.
 * @property {boolean} jobPosting.featured Adds a featured badge if true.
 * @property {string} jobPosting.published_at Determines the "new" badge. It renders if the job was published within 14 days.
 * @property {array} jobPosting.job_types An array of job types. Each job type will have a badge.
 * @property {boolean} [compact=false] Determines the size of the component. Defaults to false, meaning normal size.
 * @param {BadgesProps} props
 * @returns {JSX.Element}
 */
function Badges ({ jobPosting, compact = false }) {
  const isFeatured = jobPosting.featured
  const isRecentlyPublished = within(jobPosting.published_at, 'day', 14)

  return (
    <Group gap={compact ? 'xs' : 'md'}>
      {isFeatured && <Badge radius='sm' size={compact ? 'sm' : 'md'} color='purple'>Featured</Badge>}
      {isRecentlyPublished && <Badge radius='sm' size={compact ? 'sm' : 'md'} color='green'>New!</Badge>}
      {jobPosting.job_types.map(jobType => (
        <Badge radius='sm' size={compact ? 'sm' : 'md'} key={jobType.name} color='blue.8'>{jobType.name}</Badge>
      ))}
    </Group>
  )
}

export default React.memo(Badges)
